module.exports = __webpack_public_path__ + "media/images/lb/930-aec1b74ba2f5688ba2c88d43ddaa8589.svg";